require("./bootstrap");


import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.css";
import "@fortawesome/fontawesome-free/js/all.js";
import "@/assets/css/vendor/ion-fonts.css";
import "@/assets/css/plugins/slick.css";
import "@/assets/css/plugins/animate.css";
import "@/assets/css/plugins/jquery-ui.min.css";
import "@/assets/css/plugins/lightgallery.min.css";
import "@/assets/css/plugins/nice-select.css";
import "owl.carousel/dist/assets/owl.carousel.min.css"

import "sweetalert2/dist/sweetalert2.min.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "vue-good-table/dist/vue-good-table.css";

import "@/assets/fonts/icomoon/style.css";
import "@/assets/css/style.css";


import Vue from "vue"; 
import { HasError, AlertSuccess, AlertError } from "vform";
import VueSweetalert2 from "vue-sweetalert2";
import VueCurrencyFilter from "vue-currency-filter";
import VueSlickCarousel from 'vue-slick-carousel'
import BootstrapVue from "bootstrap-vue";
import VueGoodTablePlugin from "vue-good-table";
import Inputmask from "inputmask";


import App from "./App.vue";
import router from "./router";
import store from './store';


import globalMixins from "./mixins/globalMixins";
import mixinDate from "./mixins/mixinDate";

import "./config";
import "./filter";

import Simple from "@/layouts/Simple";
import Default from "@/layouts/Default";
import Auth from "@/layouts/Auth";
import ButtonLoader from "@/components/ButtonLoader";
import Loader from "@/components/Loader";


Vue.use(VueCurrencyFilter, {
  symbol: "MRU",
  thousandsSeparator: ".",
  fractionCount: 2,
  fractionSeparator: ",",
  symbolPosition: "back",
  symbolSpacing: true
});

Vue.component("simple-layout", Simple);
Vue.component("default-layout", Default);
Vue.component("auth-layout", Auth);
Vue.component("ButtonLoader", ButtonLoader);
Vue.component("VueSlickCarousel", VueSlickCarousel);
Vue.component(HasError.name, HasError);
Vue.component(AlertSuccess.name, AlertSuccess);
Vue.component(AlertError.name, AlertError);
Vue.component("loader", Loader);

Vue.directive("input-mask", {
  bind: function(el) {
    new Inputmask().mask(el);
  }
});

Vue.mixin(globalMixins);
Vue.mixin(mixinDate);

Vue.config.productionTip = false;

Vue.use(VueGoodTablePlugin);
Vue.use(VueSweetalert2);
Vue.use(BootstrapVue);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
